import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeSv from '@angular/common/locales/sv';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { SignInComponent } from './app/user/sign-in/sign-in.component';

registerLocaleData(localeSv, 'sv-SE');

bootstrapApplication(AppComponent, appConfig)
  .catch(() => {/* console.error(err) */});
